import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/insights/newsletters/new")({
  beforeLoad: () => {
    throw redirect({ to: "/admin/newsletter/newsletters/new" });
  },
});
